import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, className = "", y = 14 }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-20px" }}
    transition={{ duration: 0.45, delay, ease: [0.22, 1, 0.36, 1] }}
  >
    {children}
  </motion.div>
);

export const KineticLines = ({ lines, as: Tag = "h1", className = "", lineClassName = "", baseDelay = 0.08 }) => (
  <Tag className={className}>
    {lines.map((line, i) => (
      <span key={i} className="mask-line">
        <motion.span
          className={`block ${lineClassName}`}
          initial={{ y: "110%" }}
          animate={{ y: 0 }}
          transition={{ duration: 0.6, delay: baseDelay + i * 0.09, ease: [0.22, 1, 0.36, 1] }}
        >
          {line}
        </motion.span>
      </span>
    ))}
  </Tag>
);

export const SectionHead = ({ eyebrow, title, copy, dark = false, align = "left" }) => (
  <div className={`max-w-3xl ${align === "center" ? "mx-auto text-center" : ""}`}>
    {eyebrow && (
      <Reveal><p className={`eyebrow ${dark ? "eyebrow-light" : ""}`}>{eyebrow}</p></Reveal>
    )}
    <Reveal delay={0.08}>
      <h2 className={`mt-4 font-display text-3xl font-medium tracking-tight sm:text-4xl ${dark ? "text-white" : "text-ink"}`}>
        {title}
      </h2>
    </Reveal>
    {copy && (
      <Reveal delay={0.16}>
        <p className={`mt-5 text-base leading-relaxed ${dark ? "text-slate-400" : "text-steel"}`}>{copy}</p>
      </Reveal>
    )}
  </div>
);
